/**
 * Every Vidimo-owned URL the app sends a reader to, in one place rather than
 * scattered through the drawer. Most derive from a single hostname, so a
 * rebrand is one line.
 *
 * These are links and a mailbox handed to USERS, so they may only name hosts
 * that actually answer. Anything added here has to be verified serving before
 * it ships: mobile-release.yml fires on pushes to staging, so a host that is
 * merely planned goes out in a build as a dead link.
 */
const BRAND_DOMAIN = "vidimo.app";

// The apex, not `www.`: on vidimo.app the apex is canonical and serves directly,
// and `www` 301s into it. Pinning `www` would spend a redirect on every
// open.
export const MARKETING_URL = `https://${BRAND_DOMAIN}`;
export const DOCS_URL = `https://docs.${BRAND_DOMAIN}`;
export const CHANGELOG_URL = `${DOCS_URL}/changelog`;
/** The address a host adds to Claude or ChatGPT as a custom connector. */
export const MCP_CONNECTOR_URL = `https://mcp.${BRAND_DOMAIN}/mcp`;

/**
 * Linked from inside the app because App Store review guideline 5.1.1(i)
 * expects both to be reachable without leaving it — at account creation in
 * particular.
 */
export const PRIVACY_POLICY_URL = `${MARKETING_URL}/privacy`;
export const TERMS_OF_SERVICE_URL = `${MARKETING_URL}/terms`;
